import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Logo } from "@/components/Layout";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { login, googleLogin } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const u = await login(email, password); toast.success("Welcome back"); nav(u.role === "admin" ? "/admin" : "/dashboard"); }
    catch (err) { toast.error(err.response?.data?.detail || "Login failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-16">
      <div className="w-full max-w-md glass rounded-2xl p-10">
        <div className="text-center mb-8"><Logo /></div>
        <h1 className="font-display text-3xl font-semibold text-center">Welcome back</h1>
        <p className="text-gray-400 text-center text-sm mt-2">Sign in to your account</p>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="login-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="login-password" required type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="login-submit" disabled={busy} className="btn-gold w-full justify-center">{busy ? "Signing in…" : "Sign in"}</button>
        </form>
        <div className="my-6 flex items-center gap-3 text-xs text-gray-500"><div className="flex-1 h-px bg-white/10" />OR<div className="flex-1 h-px bg-white/10" /></div>
        <button data-testid="google-login" onClick={googleLogin} className="btn-ghost w-full justify-center">Continue with Google</button>
        <p className="text-sm text-gray-400 text-center mt-6">Don't have an account? <Link to="/register" className="text-[#D4AF37]">Register</Link></p>
      </div>
    </div>
  );
}
